import gql from 'graphql-tag';

export const ACCOMMODATIONS_TITLES = gql`
  query accommodations($businessOwnerId: Int) {
    accommodations(
      numberOfAccommodationPerPage: 10000
      businessOwnerId: $businessOwnerId
    ) {
      id
      title
      titleNo
    }
  }
`;

export const ACCOMMODATIONS_WITH_BOOKINGS = gql`
  query accommodations(
    $startPeriod: Date
    $endPeriod: Date
    $businessOwnerId: Int
  ) {
    accommodations(businessOwnerId: $businessOwnerId) {
      id
      title
      photo
      productCode
      checkInTime
      checkOutTime
      guestsNumber
      fromDate
      toDate
      accommodationBookings(startDate: $startPeriod, endDate: $endPeriod) {
        id
        fromDate
        toDate
        bookingNotes
        deactivationBooking
        guestFirstName
        guestLastName
        guestPhoneNumber
        guestEmail
        platform
        bookingType
        creationTime
        referenceNumber
        isRelated
        guests {
          totalPrice
          guestsNumber
          participant {
            participant
          }
        }
        payments {
          currency {
            currency
          }
          totalPrice
        }
        bookedAddOns {
          addOn {
            title
          }
          addOnCount
          totalPrice
        }
        bookedMandatoryFees {
          mandatoryFee {
            title
          }
          mandatoryFeeCount
          totalPrice
        }
        accommodation {
          id
          title
          productCode
          photo
          checkInTime
          checkOutTime
          guestsNumber
          fromDate
          toDate
          color
        }
        relatedActivitiesBookings {
          id
          activity {
            title
          }
          guests {
            totalPrice
            guestsNumber
            participant {
              participant
            }
          }
          payments {
            currency {
              currency
            }
            totalPrice
          }
          bookedAddOns {
            addOn {
              title
            }
            addOnCount
            totalPrice
          }
        }
      }
    }
  }
`;

export const ACCOMMODATIONS = gql`
  query accommodations($page: Int, $businessOwnerId: Int) {
    accommodations(
      page: $page
      numberOfAccommodationPerPage: 11
      businessOwnerId: $businessOwnerId
    ) {
      id
      photo
      title
      availability
      fromDate
      toDate
      productCode
      guestsNumber
      location
    }

    numberOfAccommodationsPages(
      numberOfAccommodationsPerPage: 11
      businessOwnerId: $businessOwnerId
    )
    accommodationsActivitiesOverview(businessOwnerId: $businessOwnerId) {
      activities {
        total
        available
        expired
      }
      accommodations {
        total
        available
        expired
      }
    }
  }
`;

export const WIDGET_ACCOMMODATIONS = gql`
  query accommodations(
    $page: Int
    $businessOwnerId: Int
    $numberOfAccommodationPerPage: Int!
    $startPeriod: Date
    $endPeriod: Date
    $guestsNumber: Int
  ) {
    accommodations(
      page: $page
      businessOwnerId: $businessOwnerId
      numberOfAccommodationPerPage: $numberOfAccommodationPerPage
      startPeriod: $startPeriod
      endPeriod: $endPeriod
      guestsNumber: $guestsNumber
    ) {
      id
      photo
      title
      titleNo
      overview
      overviewNo
      included
      includedNo
      notIncluded
      notIncludedNo
      bedDetails
      bedDetailsNo
      location
      checkInTime
      checkOutTime
      additionalInfo
      additionalInfoNo
      cancellation
      cancellationNo
      guestsNumber
      prices {
        id
        participant {
          participant
        }
        currency {
          currency
        }
        value
        day
      }
      futurePrices {
        id
        ratePlan {
          id
          title
        }
        ratePlanPrices {
          id
          value
          currency {
            currency
          }
          startDate
          endDate
        }
      }
    }
    numberOfAccommodationsPages(
      businessOwnerId: $businessOwnerId
      numberOfAccommodationsPerPage: $numberOfAccommodationPerPage
    )
  }
`;

export const BOOK_DATES = gql`
  query accommodations(
    $accommodationId: Int
    $businessOwnerId: Int
    $startPeriod: Date
    $endPeriod: Date
  ) {
    accommodations(
      accommodationId: $accommodationId
      businessOwnerId: $businessOwnerId
    ) {
      id
      bookedDates(startPeriod: $startPeriod, endPeriod: $endPeriod) {
        date
        isAvailableForCheckIn
        isAvailableForCheckOut
        deactivationBooking
      }
    }
  }
`;

export const ACCOMMODATION = gql`
  query accommodations($accommodationId: Int, $businessOwnerId: Int) {
    accommodations(
      accommodationId: $accommodationId
      businessOwnerId: $businessOwnerId
    ) {
      id

      photo
      title
      titleNo
      productCode
      guestsNumber
      location
      fromDate
      toDate
      checkInTime
      checkOutTime
      bedDetails
      bedDetailsNo
      minNights
      color

      overview
      overviewNo
      additionalInfo
      additionalInfoNo
      cancellation
      cancellationNo
      included
      includedNo
      notIncluded
      notIncludedNo

      prices {
        id
        participant {
          participant
        }
        currency {
          currency
        }
        value
        day
      }

      futurePrices {
        id
        ratePlan {
          id
          title
        }
        ratePlanPrices {
          id
          value
          currency {
            currency
          }
          startDate
          endDate
        }
      }

      addOn {
        id
        title
        titleNo
        description
        descriptionNo
        photo
        prices {
          currency {
            currency
          }
          value
        }
      }
      
      mandatoryFee {
        id
        title
        titleNo
        description
        descriptionNo
        prices {
          currency {
            currency
          }
          value
        }
      }

      accommodationbookingSet {
        deactivationBooking
        id
        toDate
        fromDate
        isCanceled
      }

      relatedActivities {
        id
        title
        titleNo
        overview
        overviewNo
        photo
        scheduleType
        pricesType
        futurePriceForm

        activitypriceSet {
          id
          participant {
            participant
          }
          currency {
            currency
          }
          days
          value
        }
      }

      platforms {
        id
        platform
        titleOnPlatform
      }
    }
  }
`;

export const GET_RATE_PLANS = gql`
  query GetRatePlans($businessOwnerId: Int) {
    ratePlans(businessOwnerId: $businessOwnerId) {
      id
      title
      prices {
        currency {
          currency
        }
        value
        startDate
        endDate
      }
    }
  }
`;
